import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishProgressbar } from './progressbar';
import { FishProgressbarConfig } from './progressbar-config';

export { FishProgressbar } from './progressbar';
export { FishProgressbarConfig } from './progressbar-config';


export class FishProgressbarModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishProgressbarModule, providers: [FishProgressbarConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ declarations: [FishProgressbar], exports: [FishProgressbar], imports: [CommonModule] }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
